import type { StatusStyle } from "@/components/ui/status-badge";

export type ConsumableTransactionType = "add" | "consume" | "adjust";

const TRANSACTION_LABELS: Record<ConsumableTransactionType, string> = {
  add: "Added",
  consume: "Consumed",
  adjust: "Adjusted",
};

/**
 * Sanctioned palette (DESIGN.md §1/§7), preserving the original semantics:
 *  - add     → emerald (stock in / positive)
 *  - consume → amber   (a decrease worth noticing; was orange)
 *  - adjust  → muted   (neutral manual correction; was a neutral blue)
 */
const TRANSACTION_CLASS: Record<ConsumableTransactionType, string> = {
  add: "bg-emerald-100 text-emerald-800 hover:bg-emerald-100",
  consume: "bg-amber-100 text-amber-800 hover:bg-amber-100",
  adjust: "bg-muted text-muted-foreground hover:bg-muted",
};

/** Resolve a consumable transaction type into a {@link StatusStyle}. */
export function consumableTransactionStyle(
  type: ConsumableTransactionType,
): StatusStyle {
  return {
    label: TRANSACTION_LABELS[type],
    className: TRANSACTION_CLASS[type],
  };
}
